<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-50"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[960px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span v-if="form.shelter_id" class="PC_Body2-R text-[#FCFCFC]">
              {{
                checkEdit ? "แก้ไขข่าวประชาสัมพันธ์" : "เพิ่มข่าวประชาสัมพันธ์"
              }}
            </span>
            <span v-else class="PC_Body2-R text-[#FCFCFC]">
              {{
                checkEdit ? "แก้ไขข่าวประชาสัมพันธ์" : "สร้างข่าวประชาสัมพันธ์"
              }}
            </span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>
          <div
            class="flex flex-col justify-center items-start gap-[30px] p-[20px] pt-[12px]"
          >
            <div class="w-full grid gap-4">
              <Input
                label="หัวข้อข่าวประชาสัมพันธ์"
                placeholder="หัวข้อข่าวประชาสัมพันธ์"
                v-model="form.title"
                :warningMessage="errors.title"
              />
              <div class="flex flex-col gap-[6px]">
                <div class="PC_Body1-SB">เนื้อหา</div>
                <textarea
                  v-model="form.description"
                  class="w-full leading-[20px] min-h-[120px] text-[14px] text-ellipsis px-2.5 py-3 border border-grey-light placeholder-grey-light font-light bg-white rounded-[6px] outline-primary resize-none"
                  placeholder="โปรดกรอกเนื้อหา..."
                >
                </textarea>
                <div
                  v-if="errors.description"
                  :class="['textError', { 'mt-[8px]': errors.description }]"
                >
                  {{ errors.description }}
                </div>
              </div>
              <div class="flex flex-col gap-[6px]">
                <!-- upload image -->
                <div class="flex flex-col items-start gap-[8px]">
                  <div class="PC_Body1-SB">แนบรูป</div>
                  <!-- hidden file input -->
                  <input
                    ref="fileInput"
                    type="file"
                    accept="image/*"
                    class="hidden"
                    @change="handleFileChange"
                  />
                  <!-- hidden file input -->
                  <div class="w-full flex items-center gap-[16px] flex-wrap">
                    <div
                      v-if="form.image && imagePreview != 'default.png'"
                      class="flex items-center gap-[4px]"
                    >
                      <div class="BodyS text-[#1F1D1F] break-all">
                        {{ imagePreview }}
                      </div>
                      <div
                        @click="removeImage"
                        class="w-[32px] h-[32px] flex items-center justify-center cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <path
                            d="M22.3236 11.325C22.7793 10.8693 22.7793 10.1306 22.3236 9.67498C21.868 9.21934 21.1293 9.21934 20.6737 9.67498L15.9987 14.3499L11.3238 9.67498C10.8681 9.21935 10.1294 9.21934 9.67377 9.67498C9.21814 10.1306 9.21814 10.8693 9.67377 11.325L14.3487 15.9999L9.67375 20.6749C9.21812 21.1305 9.21812 21.8692 9.67375 22.3249C10.1294 22.7805 10.8681 22.7805 11.3237 22.3249L15.9987 17.6499L20.6737 22.3249C21.1293 22.7805 21.868 22.7805 22.3237 22.3249C22.7793 21.8692 22.7793 21.1305 22.3237 20.6749L17.6487 15.9999L22.3236 11.325Z"
                            fill="#EB5554"
                          />
                        </svg>
                      </div>
                    </div>
                    <div v-else class="BodyS !text-[#7C7379]">
                      รูป .jpg .jpeg หรือ .png เท่านั้น
                    </div>
                    <ButtonComponent
                      v-if="form.image && imagePreview != 'default.png'"
                      :label="'เปลี่ยนรูป'"
                      :bClass="'py-[11px] px-[16px] !border-[#FBEFF8] bg-[#FBEFF8] text-[#9B237B]'"
                      :lClass="'textButtonS textButtonS--white'"
                      @clicked="uploadImage"
                    />
                    <ButtonComponent
                      v-else
                      :label="'อัปโหลดรูป'"
                      :bClass="'py-[11px] px-[16px] !border-[#9B237B] bg-[#9B237B] text-[#fff]'"
                      :lClass="'textButtonS textButtonS--white'"
                      @clicked="uploadImage"
                    />
                  </div>
                </div>
                <div v-if="errors.image" class="textError">
                  {{ errors.image }}
                </div>
              </div>
              <!-- upload image -->

              <div class="flex flex-col items-start gap-[10px]">
                <div class="PC_Body1-SB">ต้องการส่งแจ้งเตือนไปทางไลน์ OA</div>
                <div class="w-full flex items-center gap-[16px] flex-wrap">
                  <div class="w-full sm:w-1/3">
                    <Radio
                      :id="'resources_choice0'"
                      v-model="form.line_oa"
                      :name="'resources_choice0'"
                      :value="1"
                      :label="'ต้องการ'"
                    />
                  </div>
                  <div class="w-full sm:w-1/3">
                    <Radio
                      :id="'resources_choice1'"
                      v-model="form.line_oa"
                      :name="'resources_choice1'"
                      :value="0"
                      :label="'ไม่ต้องการ'"
                    />
                  </div>
                </div>
              </div>

              <div class="flex justify-end items-center gap-[10px]">
                <ButtonComponent
                  :label="'บันทึก'"
                  :bClass="'btn_shadow--onlySave'"
                  :disabled="isAllEmpty"
                  @clicked="save"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script setup>
import { ref, watch, computed } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useNewsStore } from "@/pinia/news";

const modalIsOpened = ref(false);
const input = {
  shelter_id: "",
  title: "",
  description: "",
  image: "",
  line_oa: "",
};
const form = ref({ ...input });
const errors = ref({ ...input });
const checkEdit = ref(false);
const imagePreview = ref("");
const fileInput = ref(null);
const checkImageChange = ref(false);
const { $validateMsg, $buildFormData } = useGlobals();
const newsStore = useNewsStore();

const emit = defineEmits(["success", "confirmDelete"]);

watch(
  () => form.image,
  (newVal) => {
    imagePreview.value = newVal;
  },
  { immediate: true }
);

const excludedKeys = ["shelter_id", "image"];

const isAllEmpty = computed(() => {
  return Object.entries(form.value)
    .filter(([key]) => !excludedKeys.includes(key))
    .some(([, value]) => value === "");
});

const openModal = (item, inShelterID) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  checkEdit.value = !!item;

  if (checkEdit.value) {
    form.value = {
      ...form.value,
      id: item.id,
      title: item.title,
      description: item.description,
      line_oa: item.line_oa,
      shelter_id: item.shelter_id || inShelterID || "",
      image: item.image || "",
    };
    imagePreview.value = item.image_name || "";
    checkImageChange.value = false;
  } else {
    form.value = {
      ...form.value,
      title: "",
      description: "",
      line_oa: 1,
      shelter_id: inShelterID || "",
      image: "",
    };
    imagePreview.value = "";
    checkImageChange.value = false;
  }
};

const resetForm = () => {
  form.value = { ...input };
  errors.value = { ...input };
  imagePreview.value = "";
  checkImageChange.value = false;
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
  resetForm();
};

const uploadImage = () => {
  fileInput.value.click();
};

const handleFileChange = (e) => {
  const file = e.target.files[0];
  e.target.value = "";
  if (
    file &&
    /\.(jpe?g|png)$/i.test(file.name) &&
    ["image/jpeg", "image/png"].includes(file.type)
  ) {
    form.value.image = file;
    imagePreview.value = file.name;
    checkImageChange.value = true;
  } else {
    alert("กรุณาเลือกไฟล์ .jpg, .jpeg หรือ .png เท่านั้น");
  }
};

const removeImage = () => {
  imagePreview.value = "";
  form.value.image = null;
};

const save = () => {
  if (checkEdit.value) {
    update();
  } else {
    add();
  }
};

const isURL = (str) => {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};

const update = async () => {
  let body = null;

  console.log('form.value.image',form.value.image);
  
  if (checkImageChange.value && form.value.image != null) {
    body = { ...form.value }; // รวม image
  } else if (isURL(form.value.image)) {
    const { image, ...rest } = form.value;
    body = rest; // ตัด image ออก
  } else {
    body = {
      ...form.value,
      image: "",
    };
  }

  let formData = new FormData();
  const data0 = $buildFormData(formData, body);
  // console.log(data0);

  await newsStore
    .updateNew(form.value.id, data0)
    .then((response) => {
      if (response.status === 200) {
        emit("success", response.data.message);
        closeModal();
      }
    })
    .catch((error) => {
      if (error) {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

const add = async () => {
  let formData = new FormData();
  const data0 = $buildFormData(formData, form.value);
  await newsStore
    .createNew(data0)
    .then((response) => {
      if (response.status === 201) {
        emit("success", response.data.message);
        closeModal();
      }
    })
    .catch((error) => {
      if (error) {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>
    
<style lang="scss" scoped>
.BodyS {
  /* Body/s */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  letter-spacing: 0.1px;
}
</style>